import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialAppState } from 'store/app/initial'
import { boltApi } from 'store/api/bolt-api'
import Router from 'next/router'
import { Language } from 'types/language'
import { filterAndSortProducers } from 'utils/producers'
import { SetSelectedProducerPayload, UpdateOpportunityIdPayload } from './types'
import { State } from 'types/producer'

export const AppSlice = createSlice({
  initialState: initialAppState,
  name: 'app',
  reducers: {
    setSelectedProducer: (state, action: PayloadAction<SetSelectedProducerPayload>) => {
      const { producerSlug } = action.payload
      return {
        ...state,
        selectedProducer: producerSlug
      }
    },
    updateOpportunityId: (state, action: PayloadAction<UpdateOpportunityIdPayload>) => {
      const { opportunityId } = action.payload
      return {
        ...state,
        opportunityId
      }
    },
    updateAccountId: (state, action: PayloadAction<string | undefined>) => {
      return {
        ...state,
        accountId: action.payload
      }
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(boltApi.endpoints.getProducers.matchFulfilled, (state, { payload }) => {
      const language = Router.locale as Language
      const sortedProducers = filterAndSortProducers({
        language,
        producers: Object.values(payload)
      })

      const firstAvailableProducer = sortedProducers.find((p) => p.state === State.AVAILABLE)

      return {
        ...state,
        selectedProducer: firstAvailableProducer?.slug || sortedProducers[0]?.slug
      }
    })
  }
})

export const { setSelectedProducer, updateOpportunityId, updateAccountId } = AppSlice.actions

export default AppSlice.reducer
